import { kebabCase } from 'lodash';

import { useNextPaymentPeriodField } from '@makemydeal/dr-dash-components';

import { ReadOnlyValueRow } from '../../ReadOnlyValueRow';

export const FlexBuyNextPaymentsRow = () => {
    const { label, value } = useNextPaymentPeriodField();

    return <ReadOnlyValueRow rowKey="flexBuyNextPayments" label={label} value={value} labelTestId={kebabCase(label)} />;
};
